import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import $ from "jquery";
import { SaveService } from "../services/save.service";
import { ApiService } from "../services/api.service";
import { environment } from "../../environments/environment";

@Component({
  selector: "app-footer",
  standalone: false,
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  providers: [ApiService]
})
export class FooterComponent implements OnInit, OnDestroy {
  baseURL = environment.assetsURL.assetsPath;
  brandName;
  logo;
  isSuccess = false;
  newserror: any = "";
  news_sucess: any = false;
  currentYear: any = '';
  googlegenericpassval: any = "";
  applegenericpassval: any = "";
  android = false;
  ios = false;
  walletsDetected = false;
  desktop: any = true;
  showemailpopup: any = false;
  UserInputEmailcard: string = "";
  UserInputEmailcarderror: any = "";
  UserInputEmailcardsuccess: any = "";
  Sendtext: any = "Send";
  walletLoading: 'apple' | 'google' | null = null;

  private readonly passBin = '023518';
  private readonly passPcn = 'ARX';
  private readonly passGroup = '100-4542';
  private passMessageTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly passMessageHideMs = 5000;

  newsletter() {
    var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var newsLetterMail = $("input[name='email_']").val();
    if (newsLetterMail != "") {
      this.apiService
        .addActiveContact(newsLetterMail, "", "", "newsletter")
        .subscribe(data => {
          $("input[name='email_']").val("");
          $('.fnewss').show();
        });
    } else if (!newsLetterMail.match(mailformat) && newsLetterMail != "") {
      $("#newsvalidator")
        .css({ display: "block", color: "red" })
        .prev()
        .css("border-color", "red");
      this.newserror = "Please enter a valid email address";
    } else {
      $("#newsvalidator")
        .css({ display: "block", color: "red" })
        .prev()
        .css("border-color", "red");
      this.newserror = "Please enter a valid email address";
    }
  }
  removeerror(event) {
    $("#newsvalidator")
      .hide()
      .prev()
      .removeAttr("style");
    $('.fnewss').hide();
  }

  constructor(
    private saveService: SaveService,
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    let userAgent = window.navigator.userAgent;
    let devicetype = this.GetUserAgent(userAgent);
    this.walletsDetected = true;
    if (devicetype == "Desktop") {
      this.android = true;
      this.ios = true;
    } else if (devicetype == "iPhone") {
      this.android = false;
      this.ios = true;
    } else if (devicetype == "Android") {
      this.android = true;
      this.ios = false;
    }
    $(".footer-nav a").click(function () {
      $(".navbar-nav a").removeClass("home-active");
    });
    this.brandName = this.saveService.getFooterBrandName();
    this.logo = this.saveService.getLogo();
    this.currentYear = new Date().getFullYear();
  }

  ngOnDestroy() {
    this.clearPassMessageTimeout();
  }

  private clearPassMessageTimeout(): void {
    if (this.passMessageTimeout) {
      clearTimeout(this.passMessageTimeout);
      this.passMessageTimeout = null;
    }
  }

  private schedulePassMessageHide(): void {
    this.clearPassMessageTimeout();
    this.passMessageTimeout = setTimeout(() => {
      this.UserInputEmailcarderror = "";
      this.UserInputEmailcardsuccess = "";
      this.passMessageTimeout = null;
    }, this.passMessageHideMs);
  }

  appleWalletPopup() {
    this.showemailpopup = !this.showemailpopup;
    this.UserInputEmailcard = "";
    this.UserInputEmailcarderror = "";
    this.UserInputEmailcardsuccess = "";
    this.clearPassMessageTimeout();
  }
  slideToggle() {
    if (screen.width <= 767) {
      if ($('.navbar').hasClass('less')) {
        $('#slide-icon').attr('src', 'assets/images/close.png').delay("slow").fadeIn();
      }
    }
  }
  GetBrowserName(UserAgent_Raw) {
    if (/Firefox/i.test(UserAgent_Raw)) {
      return 'Firefox';
    } else if (/Chrome/i.test(UserAgent_Raw)) {
      return 'Chrome';
    } else if (/Safari/i.test(UserAgent_Raw)) {
      return 'Safari';
    } else if (/MSIE|Trident/i.test(UserAgent_Raw)) {
      return 'Internet Explorer';
    } else if (/Edge/i.test(UserAgent_Raw)) {
      return 'Edge';
    } else if (/Opera|OPR/i.test(UserAgent_Raw)) {
      return 'Opera';
    } else if (/Brave/i.test(UserAgent_Raw)) {
      return 'Brave';
    } else if (/Vivaldi/i.test(UserAgent_Raw)) {
      return 'Vivaldi';
    } else if (/Yandex/i.test(UserAgent_Raw)) {
      return 'Yandex';
    } else if (/Chromium/i.test(UserAgent_Raw)) {
      return 'Chromium';
    } else {
      return 'Unknown';
    }
  }
  GetUserAgent(UserAgent_Raw) {
    if (/iPhone|iPod/i.test(UserAgent_Raw)) {
      return 'iPhone';
    }
    if (/iPad/i.test(UserAgent_Raw)) {
      return 'iPhone';
    }
    if (/Android/i.test(UserAgent_Raw)) {
      return 'Android';
    }
    return 'Desktop';
  }

  private getUserGroup(): string {
    const currentURL = location.href;
    if (currentURL.includes('_branch_match_id')) {
      return window.localStorage.getItem('UserGroup') || '';
    }
    return window.localStorage.getItem('UserGroup') || 'GHRX334';
  }

  private fetchApplePassLink(): Promise<string> {
    if (this.applegenericpassval) {
      return Promise.resolve(this.applegenericpassval);
    }
    const group = this.getUserGroup();
    return new Promise((resolve, reject) => {
      this.apiService.applegeneric(this.passBin, this.passPcn, this.passGroup, group)
        .subscribe({
          next: (data) => {
            const url = data?.[0]?.passlink || '';
            if (url) {
              this.applegenericpassval = url;
              resolve(url);
            } else {
              reject(new Error('No Apple pass link returned'));
            }
          },
          error: reject
        });
    });
  }

  private fetchGooglePassLink(): Promise<string> {
    if (this.googlegenericpassval) {
      return Promise.resolve(this.googlegenericpassval);
    }
    const group = this.getUserGroup();
    return new Promise((resolve, reject) => {
      this.apiService.googlegeneric(this.passBin, this.passPcn, this.passGroup, group)
        .subscribe({
          next: (data) => {
            const url = data?.[0]?.passlink || '';
            if (url) {
              this.googlegenericpassval = url;
              resolve(url);
            } else {
              reject(new Error('No Google pass link returned'));
            }
          },
          error: reject
        });
    });
  }

  private isNonSafariIPhone(userAgent: string, devicetype: string): boolean {
    return devicetype === 'iPhone'
      && !(/Safari/.test(userAgent) && /Version/.test(userAgent) && !/CriOS/.test(userAgent));
  }

  private navigateToPass(url: string, devicetype: string): void {
    if (devicetype === 'iPhone' || devicetype === 'Android') {
      window.location.assign(url);
      return;
    }
    const opened = window.open(url, '_blank');
    if (!opened) {
      window.location.assign(url);
    }
  }

  onWalletClick(type: 'apple' | 'google') {
    if (!isPlatformBrowser(this.platformId) || this.walletLoading) {
      return;
    }

    const userAgent = window.navigator.userAgent;
    const devicetype = this.GetUserAgent(userAgent);
    const isNonSafariIPhone = this.isNonSafariIPhone(userAgent, devicetype);
    const cachedUrl = type === 'apple' ? this.applegenericpassval : this.googlegenericpassval;

    if (cachedUrl) {
      if (type === 'apple' && isNonSafariIPhone) {
        this.showemailpopup = true;
      } else {
        this.navigateToPass(cachedUrl, devicetype);
      }
      return;
    }

    this.walletLoading = type;
    const fetchFn = type === 'apple' ? () => this.fetchApplePassLink() : () => this.fetchGooglePassLink();

    fetchFn()
      .then((url) => {
        if (type === 'apple' && isNonSafariIPhone) {
          this.UserInputEmailcard = "";
          this.UserInputEmailcarderror = "";
          this.UserInputEmailcardsuccess = "";
          this.clearPassMessageTimeout();
          this.Sendtext = "Send";
          this.showemailpopup = true;
        } else {
          this.navigateToPass(url, devicetype);
        }
      })
      .finally(() => {
        this.walletLoading = null;
      });
  }

  SharePassonemail() {
    let email = this.UserInputEmailcard;
    if (!email) {
      this.UserInputEmailcarderror = "Please fill this fields.";
      this.UserInputEmailcardsuccess = "";
      this.schedulePassMessageHide();
      return;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.UserInputEmailcarderror = "Please enter a valid email address.";
      this.UserInputEmailcardsuccess = "";
      this.schedulePassMessageHide();
      return;
    }
    this.UserInputEmailcarderror = "";
    this.UserInputEmailcardsuccess = "";
    this.clearPassMessageTimeout();
    this.Sendtext = "Sending";
    this.apiService.SendChromeemail(this.applegenericpassval, email)
      .subscribe({
        next: (data) => {
          if (data[0].StatusMessage == "Mail sent successfully") {
            this.Sendtext = "Sent";
            this.UserInputEmailcard = "";
            this.UserInputEmailcardsuccess = "Mail sent successfully! Check your inbox.";
            this.schedulePassMessageHide();
            setTimeout(() => {
              this.Sendtext = "Send";
            }, 1500);
          } else {
            this.UserInputEmailcarderror = data[0].StatusMessage || "Unable to send email. Please try again.";
            this.Sendtext = "Send";
            this.schedulePassMessageHide();
          }
        },
        error: () => {
          this.UserInputEmailcarderror = "Unable to send email. Please try again.";
          this.Sendtext = "Send";
          this.schedulePassMessageHide();
        }
      });
  }
  ClearMessage() {
    this.UserInputEmailcarderror = "";
    this.UserInputEmailcardsuccess = "";
    this.clearPassMessageTimeout();
  }
}
